// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"course"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M20 2L20 22L4 22L4 2L20 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M16 2L12 2L12 7.5L14 6L16 7.5L16 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M16 2L12 2L12 7.5L14 6L16 7.5L16 2Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20 2V22H4L4 2L20 2Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-course')
export default class CourseIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'course',
    }
  }
}
